/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
// eslint-disable-next-line
// eslint-disable-next-line no-console
/* eslint-disable no-alert */
/* eslint-disable */
import React, { useEffect, useState } from "react";
import { logo, baricon, baricon1, noteicon1 } from "../components/imagepath";
import { Link, useNavigate } from "react-router-dom";
import useUser from "../hooks/useUser";
import useToast from "../hooks/userToast";
import { Button, Tooltip } from "antd";
import apiClient from "../utils/apiClient";
import { DeleteOutline } from "@mui/icons-material";
import { onMessage } from "firebase/messaging";
import { messagingResolve } from "../firebase/firebaseConfig";
import { socket } from "../utils/socket";
// import { deleteToken, getToken } from "firebase/messaging";
// import { messaging } from "../approuter";

// Firebase credentials

const DoctorHeader = () => {
  const { name, role, userID } = useUser();
  const { toastSuccess } = useToast();
  const navigate = useNavigate();
  const { isRadiologist, isQualityChecker } = useUser();
  const [notificationData, setNotificationData] = useState();
  const [newNotifications, setNewNotifications] = useState([]);
  const [unreadNotification, setUnreadNotificationCount] = useState();
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
  };

  const handlesidebarmobilemenu = () => {
    document.body.classList.toggle("slide-nav");
    document.getElementsByTagName("html")[0].classList.toggle("menu-opened");
    document
      .getElementsByClassName("sidebar-overlay")[0]
      .classList.toggle("opened");
  };
  const handleLogout = () => {
    navigate("/");
    // Clear localStorage
    localStorage.clear();
    toastSuccess("Logged Out");
    // Navigate to the login page
  };

  const openDrawer = () => {
    setNewNotifications([]);
    const notificationPanel = document.querySelector(".notification-panel");
    notificationPanel?.classList.toggle("show");
  };

  useEffect(() => {
    const fetchUnreadNotificationCount = async () => {
      const url = `notification/unreadCount?${
        !isRadiologist ? `qualityId=${userID}` : `radioId=${userID}`
      }`;
      try {
        const response = await apiClient.get(url);
        setUnreadNotificationCount(response.data.count);
        // console.log("response-->", response);
      } catch (error) {
        console.log("error-->", error);
      }
    };
    fetchUnreadNotificationCount();
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const notificationPanel = document.querySelector(".notification-panel");
      if (notificationPanel?.classList.contains("show")) {
        if (!notificationPanel.contains(event.target)) {
          console.log("false"); // User clicked outside the notification panel
          notificationPanel.classList.remove("show");
        } else {
          console.log("true"); // User clicked inside the notification panel
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getAllNotifications = async () => {
    try {
      const url = `notification?${
        !isRadiologist ? `qualityId=${userID}` : `radioId=${userID}`
      }`;
      const response = await apiClient.get(url);
      // console.log("notification dataaaa ===> ", response?.data);
      setNotificationData(response?.data?.Notification?.data);
      setUnreadNotificationCount(0);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const handleuserNotification = (notification) => {
      // console.log("socket notification-->", notification);
      setUnreadNotificationCount((prevCount) => prevCount + 1);
    };
    socket.on("user:notification", handleuserNotification);
    socket.emit("join:notification", userID);
  }, [socket]);
  // useEffect(() => {
  //   console.log("notifications", newNotifications);
  //   // getAllNotifications();
  // }, [newNotifications]);

  const handleDeleteNotification = async (notiID) => {
    try {
      await apiClient.delete(`notification/${notiID}`);
      getAllNotifications();
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const handleForegroundMessages = () => {
      if (messagingResolve) {
        onMessage(messagingResolve, (payload) => {
          // console.log("Foreground message payload:::::::::::", payload);
          // Handle the message payload here
          if (
            "Notification" in window &&
            Notification.permission === "granted"
          ) {
            navigator.serviceWorker.ready.then((registration) => {
              registration.showNotification(payload.data.title, {
                body: payload.data.body,
                icon: payload.data.icon,
              });
            });
          }
          setNewNotifications((prevState) => [
            ...prevState,
            {
              title: payload?.data?.title,
              body: payload?.data?.body,
            },
          ]);
        });
      }
    };

    handleForegroundMessages();
  }, [messagingResolve]);
  return (
    <>
      <div className="main-wrapper">
        <div className="header">
          <div className="header-left">
            <Link to="/studies" className="logo">
              <img src={logo} width={100} alt="" />
            </Link>
          </div>
          <Link id="toggle_btn" to="#" onClick={handlesidebar}>
            <img src={baricon} alt="" />
          </Link>
          <Link
            id="mobile_btn"
            className="mobile_btn float-start"
            to="#"
            onClick={handlesidebarmobilemenu}
          >
            <img src={baricon1} alt="" />
          </Link>

          <ul className="nav user-menu float-end">
            {(isRadiologist || isQualityChecker) && (
              <li
                className="nav-item dropdown d-none d-sm-block"
                onClick={getAllNotifications}
              >
                <Tooltip
                  title={
                    newNotifications?.length
                      ? `${newNotifications?.length} new notifications`
                      : "Notifications"
                  }
                >
                  <Link
                    onClick={openDrawer}
                    id="open_msg_box"
                    className="hasnotifications nav-link"
                  >
                    <img src={noteicon1} alt="" />
                    {unreadNotification > 0 ? <span className="pulse" /> : ""}
                    {unreadNotification > 0 ? (
                      <span
                        className="notification_bell"
                        style={{ background: "red", color: "white" }}
                      >
                        {unreadNotification}
                      </span>
                    ) : (
                      ""
                    )}
                  </Link>
                </Tooltip>
              </li>
            )}
            <li className="nav-item dropdown has-arrow user-profile-list">
              <Link
                to="#"
                className="dropdown-toggle nav-link user-link"
                data-bs-toggle="dropdown"
              >
                <div className="user-names">
                  <h5>{name} </h5>
                  <span>{role}</span>
                </div>
                <span className="user-img">
                  <img
                    src="https://img.freepik.com/premium-vector/man-avatar-profile-picture-vector-illustration_268834-538.jpg"
                    alt="Admin"
                  />
                </span>
              </Link>
              <div
                className="dropdown-menu"
                style={{ width: "100%", fontSize: "14px" }}
              >
                <Link className="dropdown-item" to="/profile">
                  My Profile
                </Link>
                <Link
                  className="dropdown-item"
                  to="/login"
                  onClick={handleLogout}
                >
                  Logout
                </Link>
              </div>
            </li>
          </ul>
        </div>

        {/* Notification Panel */}
        <div className="notification-panel">
          <h5>Notifications</h5>
          {notificationData?.length > 0 ? (
            notificationData?.map((element) => (
              <ul key={element.id} className="d-flex justify-content-between">
                <li>
                  <p style={{ wordWrap: "break-word" }}>{element?.message}</p>
                </li>
                <Tooltip>
                  <Button
                    onClick={() => {
                      handleDeleteNotification(element?.id);
                    }}
                  >
                    <DeleteOutline fontSize="16px" />
                  </Button>
                </Tooltip>
              </ul>
            ))
          ) : (
            <p
              className="d-flex justify-content-center"
              style={{ color: "#93a2a5", fontSize: "12px" }}
            >
              No Notifications to show
            </p>
          )}
          {notificationData?.length > 0 && (
            <div className="notification_section">
              <a href="#">View all Notifications</a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DoctorHeader;
